"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _immutable = require("immutable");

var _TaskTypes = require("customer-data-objects/engagement/TaskTypes");

var _getAssociatedObject = _interopRequireDefault(require("./utils/getAssociatedObject"));

var TaskPlaylistConfigRecord =
/*#__PURE__*/
function (_Record) {
  (0, _inherits2.default)(TaskPlaylistConfigRecord, _Record);

  function TaskPlaylistConfigRecord() {
    (0, _classCallCheck2.default)(this, TaskPlaylistConfigRecord);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(TaskPlaylistConfigRecord).apply(this, arguments));
  }

  (0, _createClass2.default)(TaskPlaylistConfigRecord, null, [{
    key: "create",
    value: function create(_ref) {
      var title = _ref.title,
          total = _ref.total,
          tasks = _ref.tasks,
          query = _ref.query,
          redirectUrl = _ref.redirectUrl;
      var firstTask = tasks.first();

      if (!firstTask) {
        return null;
      }

      var association = (0, _getAssociatedObject.default)(firstTask);
      var taskIds = tasks.map(function (task) {
        return task.getIn(['engagement', 'id']);
      });
      var firstTaskType = firstTask.getIn(['metadata', 'taskType']);
      var interaction;

      if (firstTaskType === _TaskTypes.CALL) {
        interaction = 'call';
      } else if (firstTaskType === _TaskTypes.EMAIL) {
        interaction = 'email';
      }

      return new TaskPlaylistConfigRecord({
        currentTaskAssociationId: association.get('associationId'),
        currentTaskAssociationType: association.get('objectType'),
        currentTaskId: firstTask.getIn(['engagement', 'id']),
        interaction: interaction,
        query: query,
        title: title,
        redirectUrl: redirectUrl,
        taskIds: taskIds,
        total: total
      });
    }
  }, {
    key: "fromJS",
    value: function fromJS(data) {
      return new TaskPlaylistConfigRecord((0, _immutable.fromJS)(data));
    }
  }]);
  return TaskPlaylistConfigRecord;
}((0, _immutable.Record)({
  pageSize: 25,
  currentTaskId: null,
  currentTaskAssociationId: null,
  currentTaskAssociationType: null,
  title: '',
  interaction: null,
  // call, email, note, or null
  taskIds: (0, _immutable.List)(),
  query: null,
  total: 0,
  redirectUrl: ''
}, 'TaskPlaylistConfigRecord'));

exports.default = TaskPlaylistConfigRecord;
module.exports = exports.default;